<div class="d-flex h-90">
  <div class="login-container m-auto">
    <div class="card boxshadow">
      <div class="card-header bg-secondary dark text-white clearfix">
        <i class="fa fa-lock" aria-hidden="true"></i> Connexion
        <button *ngIf="isModal" type="button" class="close float-right text-light" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body">
        <div class="col-md-12">
          <form *ngIf="formResetToggle" class="login" name="loginForm" #f="ngForm" novalidate
                (ngSubmit)="f.form.valid ? login() :
                          (!username.valid && showErrorAlert('Le nom d&rsquo;utilisateur est requis.', 'Entrez un nom d&rsquo;utilisateur valide.'));
                          (!password.valid && showErrorAlert('Le mot de passe est requis.', 'Entrez un mot de passe valide.'))">
            <div class="form-group row">
              <label class="col-form-label col-md-3" for="login-username">Nom d&apos;utilisateur :</label>
              <div class="col-md-9">
                <input type="text" id="login-username" name="username" placeholder="Nom d&rsquo;utilisateur" autocomplete="username" class="form-control" [ngClass]="{'is-valid': f.submitted && username.valid, 'is-invalid' : f.submitted && !username.valid}"
                       [(ngModel)]="userLogin.userName" #username="ngModel" required />
                <span class="invalid-feedback" *ngIf="f.submitted && !username.valid">
                  Le nom d&rsquo;utilisateur est requis.
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-md-3" for="login-password">Mot de passe :</label>
              <div class="col-md-9">
                <input type="password" id="login-password" name="password" placeholder="Mot de passe" autocomplete="current-password" class="form-control" [ngClass]="{'is-valid': f.submitted && password.valid, 'is-invalid' : f.submitted && !password.valid}"
                       [(ngModel)]="userLogin.password" #password="ngModel" required />
                <span class="invalid-feedback" *ngIf="f.submitted && !password.valid">
                  Le mot de passe est requis.
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="offset-md-3 col-md-9">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input " id="login-rememberme" name="rememberMe" [(ngModel)]="userLogin.rememberMe">
                  <label class="form-check-label" for="login-rememberme">Se souvenir de moi</label>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="offset-md-3 col-md-9">
                <button type="submit" class="btn btn-info" [disabled]="isLoading">
                  <i *ngIf="isLoading" class='fa fa-circle-o-notch fa-spin'></i> {{isLoading ? 'Connexion...' : 'Connexion'}}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
